export default "__VITE_ASSET__CMbUl9UB__"